/**
 * Die Icons der Oberfläche. Seit dem 2026-09-11 Zeichen aus dem **IcoMoon-Font**, den der
 * Nutzer selbst zusammenstellt — vorher waren es von mir gezeichnete SVG-Pfade.
 *
 * Wer was zeigt, steht in `assets/icomoon/zuordnung.json` (vom Nutzer auf
 * `docs/icon-zuordnung.html` festgelegt); daraus erzeugt `tools/icon-einbau.mjs` die Tabelle
 * `iconGlyphs.ts` und legt den Font nach `public/fonts/icomoon/`. Eingebunden wird er lokal
 * in `styles/fonts.css` — die App muss im Prüfungsbetrieb ohne Netz laufen.
 *
 * Die alten Entwürfe liegen als `tools/icon-entwuerfe.json`; die Zuordnungsseite zeigt sie
 * weiter in der linken Spalte, damit erkennbar bleibt, was ein Icon einmal darstellen sollte.
 */

import { GLYPHEN, type IconName } from './iconGlyphs';
import stil from './Icon.module.css';

export type { IconName };

interface IconProps {
  name: IconName;
  /** Kantenlänge in Pixeln; beim Font ist das die Schriftgröße. */
  size?: number;
  color?: string;
}

export function Icon({ name, size = 18, color = 'currentColor' }: IconProps) {
  return (
    <span
      className={stil.icon}
      // Greift das Stylesheet von außen auf ein Icon zu (das Aktualisieren-Symbol dreht sich
      // während der Abfrage), dann über dieses Merkmal — der Klassenname kommt aus einem
      // CSS-Modul und ist von anderen Dateien aus nicht ansprechbar.
      data-icon={name}
      style={{ fontSize: size, color }}
      aria-hidden="true"
    >
      {GLYPHEN[name]}
    </span>
  );
}
